export default __webpack_public_path__ + "static/media/expl_gradcam_13_DE.559e6f29.png";